import { useGet, useAuth } from "@onefront/react-sdk";
import { useCurrentTenant } from "@drift/oneplatfront";
import { generateHeaders } from "../../../utils/generate-headers";

interface ParamsFetch {
    headers?: any;
}

interface IuseGetBusiness {
    (workspaceId?: string, businessId?: string, lazy?: boolean): {
        data?: any;
        loading?: boolean;
        fetch?: (fetchConfig?: ParamsFetch) => Promise<any>;
    };
}

export const useGetBusiness: IuseGetBusiness = (workspaceId, businessId, lazy = true) => {
    const { tenant } = useCurrentTenant(true);
    return useGet(`rnd:core:workspace-read:api://v2/workspaces/${workspaceId}/business/${businessId}`, {
        params: {},
        headers: {
            ...generateHeaders(useAuth(), tenant?.itemId, workspaceId)
        },
        lazy
    });
};
